import axios from 'axios';
import { postContactUrl, postJobRequestUrl, fileUploadUrl, resumeUploadUrl, guidUrl } from "./API_Endpoints"

function postGuidpayload() {
    let routingUrl = window.location.href;
    let routingPath = routingUrl.split('?')[0];

    var cookieGuid = getCookieGuid();
    var payload = `guid=${cookieGuid[0]}&requestUrl=${routingPath}&source=${cookieGuid[1]}`
    let baseUrl = `${guidUrl}?${payload}`;
    const req = new XMLHttpRequest();
    req.open("GET", baseUrl);
    req.send();
}

async function postGuid() {
    let routingUrl = window.location.href;
    var cookieGuid = getCookieGuid();

    var formData = new FormData();
    formData.append('guid', cookieGuid[0]);
    formData.append('requestUrl', routingUrl);
    formData.append('source', cookieGuid[1]);
    // fetch(guidUrl, {
    //     method: 'POST',
    //     body: formData,
    // })
}


async function postContactToService(payload) {
    var cookieGuid = getCookieGuid();
    const params = `guid=${cookieGuid[0]}&companyName=${payload['CompanyName']}&companyUrl=${payload['CompanyUrl']}
    &contactName=${payload['ContactName']}&designation=${payload['Designation']}&emailId=${payload['emailId']}
    &directNo=${payload['directNo']}&brief=${payload['brief']}`;
    let baseUrl = `${postContactUrl}?${params}`;
    try{
        const response = await fetch(baseUrl);
        try {
            const data = await response.json();
            return data;
        } catch (err) {
            console.log(err);
            return;
        }
    }
    catch (err) {
        console.log(err);
        return;
    }
}

async function postJobRequestToService(payload, resume) {

    const formData = new FormData();
    formData.append('file', resume, resume.name);
    formData.append('applicantName', payload['applicantName']);
    formData.append('applicantEmail', payload['applicantEmail']);
    formData.append('applicantPhno', payload['applicantPhno']);
    formData.append('applicantDesc', payload['applicantDesc']);
    formData.append('applicantRole', payload['applicantRole']);
    
    var requestOptions = {
        method: 'POST',
        body: formData
      };

    try{
        const response = await fetch(postJobRequestUrl, requestOptions);
        try {
            const data = await response.json();
            return data;
        } catch (err) {
            console.log(err);
            return;
        }
    }
    catch (err) {
        console.log(err);
        return;
    }
}

function fileUpload(file) {
    var data = new FormData();
    data.append('file', file, file.name);
    var config = {
        headers: {
            'accept': '*/*',
            'content-type': 'multipart/form-data',
            'Authorization': 'Bearer eyJhbGciOiJIUzUxMiIsInR5cCI6IkpXVCJ9.eyJJZCI6IjQwZTJjY2ZmLWYxODUtNDZlYy04Mzk0LWVmNmQ4MzY4MDI0ZSIsInN1YiI6InNyaWthbnRoQHN2ZWdpbGUuY29tIiwiZW1haWwiOiJzcmlrYW50aEBzdmVnaWxlLmNvbSIsImp0aSI6IjVjMDVkMzMxLTBmMzUtNDcxMC1hOTZkLTkyNTM2N2QwZGJiMSIsIm5iZiI6MTY3OTkwNTU0MSwiZXhwIjoxOTk1NTI0NzQwLCJpYXQiOjE2Nzk5MDU1NDEsImlzcyI6Imh0dHBzOi8vc3ZlZ2lsZS5jb20iLCJhdWQiOiJzdmVnaWxlIn0.B9VzrSIRgduQ_gpHAz9Ip7vnn_9wlcTfYt2jjRYopNTOY3gs5DDcZS1aWthzfyJ1B5RLFMUGxqjamwKidV-iNQ'
        }
    }
    return axios.post(fileUploadUrl, data, config)
}

function resumeUpload(resume) {
    var data = new FormData();
    data.append('file', resume, resume.name);
    var config = {
        headers: {
            'accept': '*/*',
            'content-type': 'multipart/form-data',
            'Authorization': 'Bearer eyJhbGciOiJIUzUxMiIsInR5cCI6IkpXVCJ9.eyJJZCI6IjQwZTJjY2ZmLWYxODUtNDZlYy04Mzk0LWVmNmQ4MzY4MDI0ZSIsInN1YiI6InNyaWthbnRoQHN2ZWdpbGUuY29tIiwiZW1haWwiOiJzcmlrYW50aEBzdmVnaWxlLmNvbSIsImp0aSI6IjVjMDVkMzMxLTBmMzUtNDcxMC1hOTZkLTkyNTM2N2QwZGJiMSIsIm5iZiI6MTY3OTkwNTU0MSwiZXhwIjoxOTk1NTI0NzQwLCJpYXQiOjE2Nzk5MDU1NDEsImlzcyI6Imh0dHBzOi8vc3ZlZ2lsZS5jb20iLCJhdWQiOiJzdmVnaWxlIn0.B9VzrSIRgduQ_gpHAz9Ip7vnn_9wlcTfYt2jjRYopNTOY3gs5DDcZS1aWthzfyJ1B5RLFMUGxqjamwKidV-iNQ'
        }
    }
    return axios.post(resumeUploadUrl, data, config)
}

function getCookieGuid() {
    const urlParams = new URLSearchParams(window.location.search);

    let cookieBrowseType = 'Direct';
    const UrlGuid = urlParams.get('guid');
    if (UrlGuid !== null && UrlGuid !== undefined) {
        document.cookie = `guid=${UrlGuid}; expires=Fri, 31 Dec 2100 23:59:59 GMT; secure; path=/`;
        cookieBrowseType = 'Email';
    }
    let cookieGuid = getCookie('guid');

    if (cookieGuid === undefined || cookieGuid === null) {
        cookieGuid = Math.floor((Math.random()) * 0x100000000).toString(16);
    }
    return [cookieGuid, cookieBrowseType];
}

function getCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(';').shift();
}

export { postContactToService, postJobRequestToService, fileUpload, resumeUpload, postGuid } 	